import Loading from 'components/organisms/loading/Loading';
import { connect } from 'react-redux';
const mapStateToProps = (state, props) => {
    return {
        isFetchingConversation: state.rootReducer.conversation.fetching > 0,
        isFetchingLocations: state.rootReducer.locations.isFetching,
        isFetchingNotification: state.rootReducer.notification.isFetching,
        isFetchingOrganizations: state.rootReducer.organizations.isFetching,
        isFetchingStudentsMe: state.rootReducer.students.isFetching,
        isFetchingTeachersMe: state.rootReducer.teachers.isFetching,
    };
};
const enhancer = connect(mapStateToProps, {});
export default enhancer(Loading);
